import React, { useContext, useEffect } from "react";
import styled from "@emotion/styled";

import { GlobalContext } from "../data/GlobalStore";

import GlobalColors from "../assets/GlobalColors";

const FormArea = styled.form`
  margin: 20px 0 8px;
  display: flex;
  width: 100%;
  transition: 0.5s;

  label,
  input,
  button {
    border: none;
    padding: 10px;
    font-size: 1.6rem;
    outline: none;
    background-color: ${GlobalColors.blueSecondary}
  }
  input {
    margin:0;
    border-radius: 0 5px 5px 0;
    width: 100%;
    
  }
  label {
    border-radius: 5px 0 0 5px;
    padding-right: 0;
    line-height: 1;
  }
  button {
    border-radius: 0 5px 5px 0;
  }
`;

function SearchBarMobile() {
  // load global state from GlobalStore.js
  const [globalState, globalDispatch] = useContext(GlobalContext);

  useEffect(() => {
    if (globalState.isSearchBarShown) {
      const searchInput = document.querySelector('input');
      // focus doesn't work without setTimeout
      searchInput.focus();
    }
  }, [globalState.isSearchBarShown]);

  // update "isSearchBarShown" in GlobalStore.js to show/hide search input in SearchBarMobile.js component
  const toggleIsSearchBarShown = () => {
    globalDispatch({ type: "CHANGE_IS_SEARCH_BAR_SHOWN", payload: !globalState.isSearchBarShown });
  }; 

  // prevent page refresh when user submits the search form
  const onFormSubmit = (e) => {
    e.preventDefault();
  }

  // filter interventions according to user input
  const filterInterventions = (e) => {
    // update global state "SearchText" in GlobalStore.js with the user input
    globalDispatch({ type: "CHANGE_SEARCH_TEXT", payload: e.target.value });
  };

  return (
    <FormArea onSubmit={onFormSubmit}>
      <label 
        htmlFor="search" 
        onClick={toggleIsSearchBarShown}
      >
          {/* <img src={searchIconGrey} alt="search icon" /> */}
      </label>
      {globalState.isSearchBarShown &&
        <input
          type="text"
          name="search"
          placeholder="Search"
          onChange={(e) => filterInterventions(e)}
          value={globalState.searchText}
        />
      }
    </FormArea>
  );
}

export default SearchBarMobile;
